import React from 'react'
import { Link } from 'react-router-dom'

const MainFooter = () => {
    return (
        <>
            <footer className="footer__area-3">
                <div className="footer__top-3">
                    <div className="footer__top-wrapper-3">
                        <div className="footer__logo-3 pt-120">
                            <img src="/assets/imgs/logo/site-logo-white-2.png" alt="Footer Logo" />
                            <p>Helping your business
                                reach new heights with digital strategies</p>
                        </div>
                        <div className="footer__social-3">
                            <ul>
                                <li><a href="https://api.whatsapp.com/send?phone=918347406455">WhatsApp</a></li>
                                <li><a href="https://www.linkedin.com/company/sacesta">Linkedin</a></li>
                                <li><a href="https://www.instagram.com/sacesta_technologies/">Instagram</a></li>
                            </ul>
                        </div>
                        <div className="footer__contact-3">
                            <a className="end" href="https://api.whatsapp.com/send?phone=918347406455">Let’s talk</a>
                        </div>
                    </div>
                </div>

                <div className="footer__btm-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xxl-4 col-xl-4 col-lg-4">
                                <div className="footer__copyright-3">
                                    <p>© {new Date().getFullYear()} | All rights reserved by <a href="https://sacesta.com/"
                                        target="_blank" rel="noreferrer">Sacesta</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-xxl-8 col-xl-8 col-lg-8">
                                <div className="footer__nav-2">
                                    <ul className="footer-menu-2 menu-anim d-flex">
                                        <div className='d-flex flex-column gap-2'>
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About us</Link></li>
                                            <li><Link to="/our-work">Our Work</Link></li>
                                            <li><Link to="https://calendly.com/sacesta/30min">Contact us</Link></li>
                                        </div>
                                        <div className='d-flex flex-column gap-2'>                                          
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            {/* <!-- Footer area end --> */}
        </>
    )
}

export default MainFooter